const queryParams = {
    lotId: 'id',
    status: 'status',
    cancelStatus: 'cancel_checkout'
}

export default queryParams;